import { ReactNode, forwardRef } from 'react'
import { FieldValues, useController, FieldPath } from 'react-hook-form'
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  FormControlProps,
} from '@mui/material'

type FormMultiSelectCheckboxProps<FormValues extends FieldValues> = {
  name: FieldPath<FormValues>
  label: ReactNode
  formLabelSx?: FormControlProps['sx']
} & CheckboxProps

const FormMultiSelectCheckbox = forwardRef(function FormTextField<
  FormValues extends FieldValues,
>(
  {
    name,
    label,
    value,
    formLabelSx,
    ...props
  }: FormMultiSelectCheckboxProps<FormValues>,
  ref: React.Ref<HTMLButtonElement>,
) {
  const { field } = useController<FormValues>({ name })
  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          {...field}
          {...props}
          ref={ref}
          value={value}
          checked={field.value.includes(value)}
          onChange={(event, checked) => {
            const values = checked
              ? [...field.value, event.target.value]
              : field.value.filter(
                  (item: typeof value) => item !== event.target.value,
                )
            field.onChange(values)
          }}
        />
      }
      sx={{
        width: 'fit-content',
        ...formLabelSx,
      }}
    />
  )
})

export default FormMultiSelectCheckbox
